import { gql, TypedDocumentNode } from "@apollo/client";

import { SearchModulesOutput } from "types/generated";

type SearchModulesData = {
  searchModules: SearchModulesOutput;
};

export const SEARCH_MODULES_NEW: TypedDocumentNode<SearchModulesData> = gql`
  query SearchModulesNew($input: SearchInput!) {
    searchModules(input: $input) {
      edges {
        cursor
        node {
          id
          administrative
          apiHost
          branch
          description
          canWrite
          canRead
          isDisabled
          createdAt
          labels
          name
          namespace
          projectRoot
          provider
          repository
          terraformProvider
          ownerSubdomain
          moduleSource
          moduleShares {
            id
            to {
              space {
                id
                name
              }
            }
          }
          current {
            id
            number
            state
            yanked
            yankNote
            metadata {
              root {
                inputs {
                  name
                  type
                  description
                  default
                  required
                }
              }
            }
          }
          spaceDetails {
            id
            name
          }
          starred
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        endCursor
        startCursor
      }
    }
  }
`;
